import { getAccount } from 'common/services/AuthService';
import { mapProduct, mapDcVendor } from 'admin/services/AdminTemplatesService';
import { TEMPLATE_TYPE } from 'common/stores/redux/MetaStore/MetaStoreApi.types';

export const postTemplateAction = async updatedTemplate => {
    const withProduct = await mapProduct(updatedTemplate);
    return mapDcVendor(withProduct);
};

export const mapTemplateState = (state, template) => {
    const updateTemplate = {
        ...state.template.template,
        ...template.template,
    };
    if (template?.typeId === TEMPLATE_TYPE.QUOTE_TEMPLATE) {
        updateTemplate.fulfillmentDetails =
            template?.template?.fulfillmentDetails;
        updateTemplate.distributionCenter =
            template?.template?.distributionCenter;
    }
    const account = getAccount();
    return {
        ...state,
        busy: false,
        template: {
            ...state.template,
            ...template,
            template: updateTemplate,
            updatedBy: {
                id: account?.id,
                fullName:
                    account?.firstName &&
                    `${account.firstName} ${account.lastName}`,
            },
        },
    };
};
